import SystemDesktopTopBarLayout from "../../../layouts/SystemDesktopTopBarLayout";
import SystemFlashTopBarLogoLayout from "../../../layouts/SystemFlashTopBarLogoLayout";
import SystemExerciserLogoImage from "../../../images/SystemExerciserLogoImage";
import {ExerciserLogoTextSize} from "../../../../controllers/SystemExerciserLogoTextController";
import SystemDesktopTabletLeaveExerciserButton from "../../../buttons/SystemDesktopTabletLeaveExerciserButton";
import SystemFlashTopTexts from "../../../texts/SystemFlashTopTexts";
import {kExercisersTexts} from "../../../../constants/texts";

export default function ExerciserResultsDesktopTopBar({onLeaveExerciserPressed}) {
    // Used in ExerciserResults to display top bar in
    // desktop mode

    // BUILD
    return (
        <SystemDesktopTopBarLayout>
            <SystemFlashTopBarLogoLayout>
                <SystemExerciserLogoImage exerciserLogoSize={ExerciserLogoTextSize.XSMALL}/>
            </SystemFlashTopBarLogoLayout>
            <SystemFlashTopTexts title={kExercisersTexts.resultsDesktopTopTitle}
                                 subtitle={kExercisersTexts.resultsDesktopTopSubtitle}/>
            <SystemDesktopTabletLeaveExerciserButton onLeaveExerciserPressed={onLeaveExerciserPressed} />
        </SystemDesktopTopBarLayout>
    );
}